import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { convertHexToRGBA } from '../../utils'

const styles = (theme: any) => ({
  superView: {
    flex: 1,
    backgroundColor: theme?.bodyBgColor as ColorOptions,
    overflowY: 'auto',
  } as BoxProps,
  buttonBgView: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  infoContainer: {
    height: 48,
    flexDirection: 'row',
    alignItems: 'center',
    padding: 24,
    justifyContent: 'space-between',
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
  infoText: {
    fontSize: 10,
    fontFamily: 'jioType-medium',
    fontWeight: '700',
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
  } as TextProps,
  buttonText: {
    fontFamily: 'jiotype-medium',
    fontSize: 14,
    color: theme?.brandColor as ColorOptions,
    fontWeight: '500',
  } as TextProps,
  actionButtonContainer: {
    marginTop: 16,
    bottom: 0,
    alignSelf: 'flex-end',
    right: 0,
    paddingBottom: 16,
  } as BoxProps,
  mobileActionButtonContainer: {
    marginTop: 16,
    bottom: 0,
    alignSelf: 'flex-end',
    right: 0,
    paddingBottom: 16,
    width: '100%',
  } as BoxProps,
  centerAlignment: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme?.bodyBgColor as ColorOptions,
    f: 1,
  } as BoxProps,
})

export const maxCardLength = {
  none: 16,
  rupay: 16,
  maestro: 16,
  discover: 16,
  mastercard: 16,
  diners: 16,
  amex: 17,
  visa: 16,
}

export const maxCVVLength = {
  none: 3,
  rupay: 3,
  maestro: 3,
  discover: 3,
  mastercard: 3,
  diners: 3,
  amex: 4,
  visa: 3,
}

export default styles
